import React from "react";
import { Link } from "react-router-dom";
import { NAVBAR_ITEMS } from "features/layouts/landing-layout/constant";
import { Navbar as NavbarUI } from "ui";
interface NavbarProps {
  className?: string;
}
export const Navbar: React.FC<NavbarProps> = ({ className }) => {
  return (
    <NavbarUI className={className}>
      {NAVBAR_ITEMS.map((item) => {
        return (
          <Link
            to={item.href}
            key={item.href}
            className="d-flex align-items-center"
          >
            {item.title}
          </Link>
        );
      })}
      
    </NavbarUI>
  );
};
